import React from 'react';
function Trash({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M4.5 7h15M8.667 7V5.333a1.667 1.667 0 011.666-1.666h3.334a1.667 1.667 0 011.666 1.666V7m2.5 0v11.667a1.667 1.667 0 01-1.666 1.666H7.833a1.667 1.667 0 01-1.666-1.666V7h11.666z"
      />
    </svg>
  );
}

export default Trash;
